import CONSTANTS from '../../constants';

export function appointments(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.APPOINTMENT.GET.APPOINTMENTS:
            return action.appointments;
        default:
            return state
    }
}